import {
  Disclosure,
  DisclosurePanel,
  DisclosureButton,
} from '@headlessui/react';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import { DisclosureIcon } from '@/component/Icons/DisclosureIcon';
import { ListComponent } from './List';
import { getListingsVariables } from './api_utils';
import { getInitialSearchState } from '@/utils';

import styles from './Inexact.module.css';

export const ListingsInexact = ({ searchState, query, width }) => {
  const t = useTranslations();

  const inexactQuery = useMemo(
    () => ({ ...query, location: searchState.location, inexactStay: 3 }),
    [query]
  );
  const inexactSearchState = getInitialSearchState(inexactQuery);
  const inexactVariables = getListingsVariables(
    inexactSearchState.inexactStay,
    inexactSearchState.guests,
    inexactSearchState.location,
    inexactSearchState.pets,
    inexactSearchState.date,
    inexactSearchState.price,
    inexactSearchState.amenities,
    inexactSearchState.rooms,
    inexactSearchState.rating,
    inexactSearchState.tab,
  );

  return (
    <>
      <section className={styles.placeholder} data-testid="inexact-listing">
        <ListComponent
          query={inexactQuery}
          variables={inexactVariables}
          searchState={inexactSearchState}
          width={width}
        >
          {({ list, isEmpty }) =>
            isEmpty ? null : (
              <Disclosure>
                <DisclosureButton
                  className="group flex w-full justify-between items-center py-[18px] lg:py-8 max-sm:pr-3 max-lg:pr-4 lg:pr-9 border-t border-slate-100 text-left text-sm font-medium"
                  data-testid="show-alternatives-button"
                >
                  <span className="text-slate-700 text-base lg:text-2xl font-medium">
                    {t('listings.similar.title')}
                  </span>
                  <DisclosureIcon className="text-slate-400 group-data-[open]:rotate-45 group-data-[open]:transform transition ease-linear delay-100" />
                </DisclosureButton>
                <DisclosurePanel className="sm:max-list-2xl:-mx-3">
                  {list}
                </DisclosurePanel>
              </Disclosure>
            )
          }
        </ListComponent>
      </section>
    </>
  );
};
